export const VERSION = "culteva-client-v1.5.0";
